import React from "react";

import { ProjectPortfolioTag } from "@common/projectPortfolioTag";
import { SelectList } from "@common/selectList";
import { PortfolioAssignation } from "./portfolioAssignation";
import { Props } from "./types";
import { AddIcon } from "./addIcon";
import styles from "./styles.scss";

function ProjectPortfoliosList({
  portfolios,
  addPortfolios,
  removePortfolios,
}: Props) {
  return (
    <div className={styles.projectPortfoliosList}>
      {portfolios.map((portfolio) => (
        <div key={portfolio.uuid} className={styles.item}>
          <ProjectPortfolioTag
            {...portfolio}
            isRemovable
            remove={() => removePortfolios(portfolio)}
          />
        </div>
      ))}
      <div className={styles.item}>
        <SelectList inputClassName={styles.input} listClassName={styles.list}>
          {() => ({
            input: <AddIcon className={styles.icon} />,
            list: (
              <PortfolioAssignation
                selectedPortfolios={portfolios}
                addPortfolios={addPortfolios}
              />
            ),
          })}
        </SelectList>
      </div>
    </div>
  );
}

export { ProjectPortfoliosList };
